// extracted by mini-css-extract-plugin
export default {"primaryColor":"#06236c","dangerColor":"red","warningColor":"#f8b43a","secondaryColor":"#4abf2e"};